import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RetentionReportService} from './retention-report.service';
import {Observable} from 'rxjs';
import {ReportTypes} from '../reports/models/reports';

@Injectable()
export class SubscriptionRetentionReportService extends RetentionReportService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  getFilteredReport(params: any, route: string = ""): Observable<any> {
    params['report_type'] = ReportTypes.SUBSCRIPTION_RETENTION;
    return super.getFilteredReport(params, route);
  }

  getDownloadReportData(params: any): Observable<any> {
    params['report_type'] = ReportTypes.SUBSCRIPTION_RETENTION;
    return super.getDownloadReportData(params);
  }
}
